var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 266,
    viewBox: "0 0 310 266",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_248_948",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 310,
    height: 266
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.126465 0.734863H309.46V265.245H0.126465V0.734863Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_248_948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.996 252.751V261.657C105.996 263.792 107.778 265.214 109.559 265.214H203.939C206.075 265.214 207.496 263.433 207.496 261.297V252.037C260.564 234.589 300.45 191.495 309.356 138.787V138.073C309.356 135.938 307.575 134.157 305.439 134.157H4.14225C2.00684 134.157 0.225586 135.938 0.225586 138.073L0.579753 139.855C10.9079 192.563 51.8662 236.011 105.996 252.751ZM208.21 5.23493C207.142 7.01618 177.939 49.037 208.924 82.8704C223.168 98.5422 221.746 112.073 217.825 121.334H237.772C241.689 107.803 240.262 90.3495 223.882 72.9016C201.09 47.9693 224.236 14.136 224.595 13.7818C227.444 9.86513 226.017 4.87555 221.387 2.74013C216.757 0.245342 211.059 1.31305 208.21 5.23493ZM157.996 121.334H177.939C181.856 107.803 180.434 90.3495 164.049 72.9016C141.257 47.9693 164.403 14.136 164.762 13.7818C167.611 9.86513 166.184 4.87555 161.554 2.74013C156.929 0.604718 151.226 1.67243 148.377 5.58909C146.955 7.37034 118.106 49.3964 149.09 83.2297C163.335 98.5422 161.913 112.073 157.996 121.334ZM88.1891 5.23493C86.7673 7.01618 57.9183 49.037 88.9027 82.8704C103.147 98.5422 101.726 112.073 97.8089 121.334H117.752C121.668 107.803 120.241 90.3495 103.861 72.9016C81.0693 47.9693 104.215 14.136 104.575 13.7818C107.424 9.86513 105.996 4.87555 101.366 2.74013C97.0954 0.245342 91.0381 1.31305 88.1891 5.23493Z",
    fill: "#F0573E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.c613475228d858837a84ee8641f8ceb8.svg";
export { ForwardRef as ReactComponent };